module.exports = __webpack_public_path__ + "img/circle@3x.1302449b.png";